import * as auth from '../../auth'

import * as creditCardConstants from '../constants'

import * as constants from './constants'

export default function addCreditCardReducer(state = {}, action) {
    const { type } = action

    switch (type) {
        case constants.INIT_CREDIT_CARD_ADD:
            return {
                ...state,
                selectedBrand: null,
                errors: null,
            }

        case constants.CREDIT_CARD_BRAND_SELECTED:
            return {
                ...state,
                selectedBrand: action.creditCardBrand,
                errors: null,
            }

        case creditCardConstants.ADD_PAYMENT_METHOD_SUCCESS:
            return {
                ...state,
                selectedBrand: null,
            }

        case constants.INIT_3DSECURE_FLOW:
            return {
                ...state,
                verifying3DSecure: true,
            }

        case creditCardConstants.SECURE3D_RESPONSE:
            return {
                ...state,
                verifying3DSecure: false,
            }

        case constants.INGENICO_VERIFICATION_FAILED:
            return {
                ...state,
                verifying3DSecure: false,
                selectedBrand: null,
                errors: action.errors,
            }

        case constants.CLEAR_ERRORS:
            return {
                ...state,
                errors: null,
            }

        case auth.constants.LOGOUT:
            return {}

        default:
            return state
    }
}
